<template>
  <div class="row justify-content-center mt-4">
    <div class="col-12 col-md-9 col-lg-7">
      <div class="card border-top-0 rounded-0">
        <div class="card-body py-2">
          <h4 class="card-title m-0 text-center">
            Your Videos
          </h4>
        </div>
        <div class="list-group list-group-flush">
          <div
            class="list-group-item d-flex"
            v-for="item in videos"
            :key="item.id"
          >
            <section class="mr-auto text-left align-self-center">
              {{ item.videoTitle }}
            </section>
            <section class="ml-auto text-right align-self-center">
              {{ item.createdAt.toDate() | moment }}
            </section>
            <section class="mr-3 ml-5 text-right align-self-center">
              <a href="#" @click.prevent="pickDownload(item)">
                Download
              </a>
              <b-modal
                class="text-center d-flex"
                id="pick-download"
                hide-footer
                @hidden="onHidden"
              >
                <div class="mt-4 text-left align-self-center">
                  <b-form-group label="SELECT DOWNLOAD QUALITY">
                    <b-form-radio
                      v-model="selected"
                      name="quality"
                      value="High"
                    >
                      <div class="d-flex">
                        <div class="mr-4">High(720p)</div>
                        <div class="ml-4">105.8 MB</div>
                      </div>
                    </b-form-radio>
                    <b-form-radio
                      v-model="selected"
                      name="quality"
                      value="Medium"
                    >
                      <div class="d-flex">
                        <div class="mr-4">Medium(360p)</div>
                        <div class="ml-4">79.09 MB</div>
                      </div>
                    </b-form-radio>
                    <b-form-radio v-model="selected" name="quality" value="Low">
                      <div class="d-flex">
                        <div class="mr-4">Low(180p)</div>
                        <div class="ml-4">48.7 MB</div>
                      </div>
                    </b-form-radio>
                  </b-form-group>

                  <div class="mt-3">
                    Selected: <strong>{{ selected }}</strong>
                  </div>
                </div>
                <div class="text-center pb-4">
                  <a
                    class="mt-4 btn outline rounded-pill"
                    :href="item.largeURL"
                    download="myMovie.mp4"
                    target="_blank"
                    role="button"
                  >
                    <span>DOWNLOAD</span>
                  </a>
                </div>
              </b-modal>
            </section>

            <section class="mr-3 text-right align-self-center">
              <a href="#" @click.prevent="showShare()">
                Share
              </a>
            </section>

            <section
              class="btn-group align-self-right text-right"
              role="group"
              aria-label="Video Options"
            >
              <button
                class="btn btn-sm btn-outline-secondary"
                title="Delete Video"
                @click.prevent="confirmDelete(item)"
              >
                <b-modal
                  class="text-center d-flex"
                  id="confirm-delete"
                  hide-footer
                  @hidden="onHidden"
                >
                  <h3 class="mt-4 text-center">ARE YOU SURE?</h3>
                  <h6 class="mt-4 text-center">
                    Your video will be deleted.
                  </h6>
                  <h6 class="mt-4 text-center">
                    This action cannot be undone
                  </h6>
                  <div class="text-center pb-4">
                    <b-button
                      id="yes"
                      type="button"
                      variant="outline-primary"
                      class="mt-4 mr-3 outline"
                      @click.prevent="deleting()"
                    >
                      <span>YES</span>
                    </b-button>
                    <b-button
                      id="no"
                      type="button"
                      variant="outline-primary"
                      class="mt-4 outline"
                      @click.prevent="hideConfirmation()"
                    >
                      <span>NO</span>
                    </b-button>
                  </div>
                </b-modal>
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </button>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";
//import axios from "axios";
export default {
  name: "YourVideos",
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit("setUser", value);
      },
    },
    srcVid: {
      get() {
        return this.$store.state.customization.srcVid;
      },
    },
    videos: {
      get() {
        return this.$store.state.videos[this.srcVid];
      },
    },
    selected: {
      get() {
        return this.$store.state.selected;
      },
      set(value) {
        this.$store.commit("changeSelected", value);
      },
    },
  },
  components: {
    FontAwesomeIcon,
    //axios
  },
  filters: {
    moment: function(date) {
      return moment(date).format("MM/DD/YY");
    },
  },
  methods: {
    pickDownload: function(item) {
      this.item = item;
      this.$bvModal.show("pick-download");
    },
    confirmDelete: function(item) {
      this.item = item;
      this.$bvModal.show("confirm-delete");
    },
    deleting: function() {
      this.$root.$refs.App.deleteVideo(this.item);
      this.hideConfirmation();
    },
    hideConfirmation: function() {
      this.$bvModal.hide("confirm-delete");
    },
    onHidden() {
      // fires when modal is closed
      this.customization = {};
      this.step = 1;
      this.item = null;
      this.$bvModal.hide("confirm-delete");
      this.$bvModal.hide("pick-download");
    },
    showShare: function() {
      this.$bvModal.show("share");
    },
    // playing with file download from vue
    /*
      download: function() {
        // this doesn't work due to CORS, will have to proxy most likely
        this.downloadWithAxios();
        this.item = null;
        this.selected = null;
        this.$bvModal.hide("pick-download");
      },
      forceFileDownload(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "myMovie_" + this.selected + ".mp4");
        document.body.appendChild(link);
        link.click();
      },

      downloadWithAxios() {
        axios({
          method: "get",
          url: this.item.largeURL,
          responseType: "arraybuffer",
        })
          .then((response) => {
            this.forceFileDownload(response);
          })
          .catch(() => console.log("error occured"));
      },*/
  },
};
</script>
